// ANCHOR Base
import { Block } from 'baseui/block';
import { Plus } from 'baseui/icon';
import { LabelMedium } from 'baseui/typography';
import { Button } from 'baseui/button';

// ANCHOR Models
import { useCreateFormQuestionAnswerModalVisibilityShow } from '@lyon/scoped-models/form/create/CreateFormQuestionAnswerModalVisibility';
import { useFormQuestionActiveValue } from '@lyon/scoped-models/form/FormQuestionActive';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonCreateFormQuestionAnswer } from '@lyon/components/forms/LyonCreateFormQuestionAnswer';
import { LyonUpdateMultipleChoiceAnswerList } from './LyonUpdateMultipleChoiceAnswerList';

const START_ENHANCER = <Plus />;

export const LyonUpdateMultipleChoiceAnswer = constant(() => {
  const show = useCreateFormQuestionAnswerModalVisibilityShow();
  const activeQuestionId = useFormQuestionActiveValue();

  if (!activeQuestionId) {
    return null;
  }

  return (
    <>
      <Block
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        marginTop="40px"
        marginBottom="24px"
      >
        <LabelMedium>
          Choices
        </LabelMedium>
        <Button
          size="compact"
          kind="primary"
          type="button"
          onClick={show}
          startEnhancer={START_ENHANCER}
        >
          Add a Choice
        </Button>
      </Block>
      <LyonCreateFormQuestionAnswer
        label="Add a Choice"
        formQuestionId={activeQuestionId}
      />
      <LyonUpdateMultipleChoiceAnswerList />
    </>
  );
});
